<template>
  <div class="row">
<!--    scores: {{scores}}-->
    <div class="col-md-12">
      <nav style="border-bottom:1px solid #5f5f5f;"

           class="tabnav smalltabs pill-nav tab-nav pb-3 mb-5 justify-content-center flex-wrap">
        <template v-for="(subcategory,i) in subcategories">
          <button
            :class="(activeSubcategory === i ? 'active' : '')"
            @click.stop.prevent="activeSubcategory = i"
            class=" small btn-primary btn tb-link">
<!--            {{truncate(localizedField(subcategory,'Title'),10,'string')}}-->
            {{localizedField(subcategory,'Title')}}
          </button>
        </template>
      </nav>
    </div>
    <div class="col-md-8" v-if="vitamin.Title && subcategoryLabels.length > 0 && scoresPerSubcategory.length > 0">
      <generic-chart
        v-if="subcategoryLabels.length && scoresPerSubcategory.length"
        style="height: 400px"
        :maintain-ratio="true"
        :legend="false"
        :name="this.localizedField(vitamin,'Title')"
        :type="subcategoryLabels.length > 2 ? 'radar' : 'bar'"
        :set-labels="['Team','Previous']"
        :chart-labels="subcategoryLabels"
        :chart-data="[scoresPerSubcategory]">
      </generic-chart>
    </div>
    <div class="col-md-4">
<!--      <pre class="text-white">-->
<!--{{subcategoryLabels}}-->
<!--{{scoresPerSubcategory}}-->
<!--      </pre>-->

      <!--todo only necessary for individual reviews: -->
      <template v-if="subcategories" class="" v-for="(subcategory,i) in subcategories">
        <vitamin-subcategory v-show="activeSubcategory === i"
                             :review-type="reviewType"
                             :submission="submission"
                             :subcategory="subcategory"></vitamin-subcategory>
      </template>

    </div>
  </div>
</template>
<script>
  import GenericChart from "../Charts/GenericChart";
  import VitaminSubcategory from "./VitaminSubcategory";

  export default {
    components: {
      VitaminSubcategory,
      GenericChart
    },
    data() {
      return {
        subcategories: [],
        activeSubcategory: 0,
        subcategoriesLoaded: false,
      }
    },
    created() {
      this.getSubcategories();
    },
    methods: {
      async getSubcategories() {
        let vitaminQuestions = [];
        this.vitamin.questions.forEach(question => {
          vitaminQuestions.push(question.id)
        });
        let qParam = vitaminQuestions.join('&questions_in=');
        this.axios.get('/subcategories?questions_in=' + qParam).then(r => {
          this.subcategoriesLoaded = true;
          this.subcategories = r.data;
          // this.allSubcategoryScores();
        });
      },
      // allSubcategoryScores() {
      //   const scores = [];
      //   this.subcategories.forEach(async (subcategory) => {
      //     const avg = await this.subcategoryScores(subcategory)
      //     scores.push(avg)
      //   });
      //   this.scoresPerSubcategory = scores;
      // },
      async subcategoryScores(subcategory) {
        let submissionScores = [];
        for (const submission of this.submissions) {
          let subcategoryScore = await this.subcategoryScoresPerSubmission(subcategory, submission);
          submissionScores.push(subcategoryScore);
        }

        if (submissionScores.length < 1) {
          return 0
        }

        let sum = submissionScores.reduce((acc, val) => {
          return acc + val
        });

        return this.truncate(sum / submissionScores.length, 2)
      },
      async subcategoryScoresPerSubmission(subcategory, submission) {
        const answers = await this.getSubcategoryAnswers(subcategory, submission);
        const scores = [];
        answers.forEach((answer, index) => {
          scores.push(answer.score)
        });

        if (scores.length < 1) {
          return 0
        }

        let sum = scores.reduce((acc, val) => {
          return acc + val
        });

        return sum / scores.length
      },
      async getSubcategoryAnswers(subcategory, submission) {
        const subcategoryQuestionIds = [];
        subcategory.questions.forEach(question => {
          subcategoryQuestionIds.push(question.id)
        });
        const questionParam = subcategoryQuestionIds.join('&question_in=');
        const answers = await this.axios.get(`/answers?submission=${submission.id}&question_in=${questionParam}`);
        return answers.data
      },
    },
    computed: {
      scoresPerSubcategory(){
        let scores = [];
        // console.log('scorespersub',this.scores)
        if(this.scores.children){
          let subcategoryScores = this.scores.children
          subcategoryScores.forEach(subcategory=>{
            scores.push(this.truncate(subcategory[this.graphField],2))
          });
        }


        return scores
      },
      subcategoryLabels() {
        const labels = [];
        this.subcategories.forEach((subcategory, index) => {
          labels.push(this.localizedField(subcategory,'Title'))
        });
        return labels;
      }
    },
    props: {
      graphField: {
        type: String,
        default() {
          return 'average'
        }
      },
      scores:{
        type:Object
      },
      submission: {
        type: Object,
        default() {
          return null
        }
      },
      reviewType: {
        type: String,
        default() {
          return 'team'
        }
      },
      vitamin: {
        type: Object,
        default() {
          return null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Review/VitaminReview.vue